import React, { FC } from "react";
import "../assets/styles/styles.scss";
import Login from "../components/Login";
import ContentVisual from "../components/ContentVisual";

const LoginPage: FC = () => {
    return (
      <div className={'login-page-wrapper'}>
        <ContentVisual title={'로그인'} />
        <div className={'login-content-wrapper wrapper'}>
          <div className={'login-content flex-center'}>
            <Login /> 
          </div>
        </div>
      </div>
    )
}

export default LoginPage;
